const reducer = state => ({
  ...state,
  hasSelectedNewSlotThisPageVisit: true,
});

export default reducer;
